
import { Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Component from "vue-class-component";
import SimpleDialog from "@/components/SimpleDialog.vue";
import QrCodeTestComponent from "@/components/qrcode/QrCodeTestComponent.vue";

@Component({
  components: {
    SimpleDialog,
    QrCodeTestComponent,
  },
})
export default class TestQRCodeScanner extends Vue {
  private currentTab: string = "page";
  private displayModal: boolean = false;

  @Getter private isMobile: boolean;
}
